module.exports = __webpack_public_path__ + "01_glasses_blue.ef84df79.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer4/01_glasses_blue.png
// module id = 2yiV
// module chunks = 0